import { render, staticRenderFns } from "./InnovaDashboard.vue?vue&type=template&id=26706329&"
import script from "./InnovaDashboard.vue?vue&type=script&lang=js&"
export * from "./InnovaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InnovaDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports